/**
 * Global keyboard shortcut handlers
 * These handlers are registered at the document level and run during the capture phase
 * to prevent browser default behaviors from interfering with our application shortcuts.
 */

// Dictionary of special characters produced by Option+key combinations
const OPTION_KEY_SPECIAL_CHARS = {
  þ: 'KeyT', // Option+T produces Icelandic thorn
  '˜': 'KeyN', // Option+N produces tilde
  '†': 'KeyD', // Option+D
  '¥': 'KeyY', // Option+Y
  // Add more as needed
};

// Prevent browser from opening a new window/tab when Command+N is pressed
const preventNewWindowShortcut = (e) => {
  const { key, code, altKey, metaKey, ctrlKey } = e;

  // Handle Command+N (new window/tab)
  const isCommandN = (metaKey || ctrlKey) && (key === 'n' || key === 'N' || (key === 'Dead' && code === 'KeyN'));

  if (isCommandN) {
    // Stop propagation during capture phase to prevent the browser from handling it
    e.stopPropagation();
    e.preventDefault();

    // Log for debugging
    console.log('Prevented browser Command+N behavior');
    return;
  }

  // Handle Option+key combinations when they register as Dead keys
  if (altKey && key === 'Dead') {
    // We're only preventing the default browser behavior here
    // The actual shortcut behavior is handled by the component-level handlers
    e.preventDefault();
    console.log('Prevented browser behavior for Option+key (Dead key):', code);
    return;
  }

  // Handle known special characters produced by Option+key combinations
  if (altKey && OPTION_KEY_SPECIAL_CHARS[key]) {
    e.preventDefault();
    console.log('Prevented browser behavior for Option+key special character:', key, code);
    return;
  }
};

// Initialize global shortcut handlers
const initGlobalShortcuts = () => {
  // Use capture phase to intercept events before they reach the browser's default handlers
  document.addEventListener('keydown', preventNewWindowShortcut, { capture: true });

  console.log('Global keyboard shortcuts initialized');
};

// Clean up global shortcut handlers
const cleanupGlobalShortcuts = () => {
  document.removeEventListener('keydown', preventNewWindowShortcut, { capture: true });
};

// Initialize immediately when this file is imported
initGlobalShortcuts();

export { initGlobalShortcuts, cleanupGlobalShortcuts };
